<template>
    <page-header-wrapper>

        <a-card :bordered="false">

            <!-- 条件搜索 -->
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="48">
                        <a-col :md="8" :sm="24">
                            <a-form-item label="用户昵称" prop="userId">
                                <a-input v-model="queryParam.nickName" placeholder="请输入用户昵称" allow-clear />
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <a-form-item label="订单号" prop="orderNo">
                                <a-input v-model="queryParam.orderNo" placeholder="请输入订单号" allow-clear />
                            </a-form-item>
                        </a-col>
                        <a-col :md="!advanced && 8 || 24" :sm="24">
                            <span class="table-page-search-submitButtons"
                                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon
                                        type="redo" />重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <a-tabs v-model:activeKey="activeKey">
                <a-tab-pane key="1" tab="充值金币回调记录">
                    <!-- 增加修改 -->
                    <create-form ref="createForm" @ok="getList" />
                    <!-- 数据展示 -->
                    <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                        :pagination="false" :bordered="tableBordered" :rowKey="(record, index) => index + 1">
                        <span slot="exceptionRemark" slot-scope="text, record">
                            <Tooltip :title="text">
                                {{ text }}
                            </Tooltip>
                        </span>
                        <span slot="createTime" slot-scope="text, record">
                            {{ parseTime(record.createTime) }}
                        </span>
                        <span slot="operation" slot-scope="text, record">
                            <a-divider type="vertical" v-hasPermi="['recharge:order:edit']" />
                            <a @click="$refs.createForm.handleUpdate(record, undefined)"
                                v-hasPermi="['recharge:order:edit']">
                                <a-icon type="edit" />修改
                            </a>
                            <a-divider type="vertical" v-hasPermi="['recharge:order:remove']" />
                            <!--          <a @click="handleDelete(record)" v-hasPermi="['recharge:order:remove']">-->
                            <!--            <a-icon type="delete" />删除-->
                            <!--          </a>-->
                        </span>
                    </a-table>
                    <!-- 分页 -->
                    <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper
                        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
                        :showTotal="total => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
                </a-tab-pane>
                <a-tab-pane key="2" tab="充值vip回调记录" force-render>
                    <!-- 增加修改 -->
                    <create-form ref="createForm" @ok="getList" />
                    <!-- 数据展示 -->
                    <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                        :pagination="false" :bordered="tableBordered" :rowKey="(record, index) => index + 1">
                        <span slot="exceptionRemark" slot-scope="text, record">
                            <Tooltip :title="text">
                                {{ text }}
                            </Tooltip>
                        </span>
                        <span slot="createTime" slot-scope="text, record">
                            {{ parseTime(record.createTime) }}
                        </span>
                        <span slot="operation" slot-scope="text, record">
                            <a-divider type="vertical" v-hasPermi="['recharge:order:edit']" />
                            <a @click="$refs.createForm.handleUpdate(record, undefined)"
                                v-hasPermi="['recharge:order:edit']">
                                <a-icon type="edit" />修改
                            </a>
                            <a-divider type="vertical" v-hasPermi="['recharge:order:remove']" />
                            <!--          <a @click="handleDelete(record)" v-hasPermi="['recharge:order:remove']">-->
                            <!--            <a-icon type="delete" />删除-->
                            <!--          </a>-->
                        </span>
                    </a-table>
                    <!-- 分页 -->
                    <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper
                        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
                        :showTotal="total => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
                </a-tab-pane>
            </a-tabs>


        </a-card>
    </page-header-wrapper>
</template>

<script>
import { pageDistribution, listDistribution, delDistribution } from '@/api/user/distribution'
import { pageOrder, pageOrder2, listOrder, delOrder } from '@/api/recharge/order'
import { tableMixin } from '@/store/table-mixin'

export default {
    name: 'Distribution',
    mixins: [tableMixin],
    data() {
        return {
            activeKey: "1",
            list: [],
            selectedRowKeys: [],
            selectedRows: [],
            // 高级搜索 展开/关闭
            advanced: false,
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            ids: [],
            loading: false,
            total: 0,
            // 查询参数
            queryParam: {
                type: null,
                title: null,
                num: null,
                pageNum: 1,
                pageSize: 10
            },
            columns: [
                {
                    title: 'uid',
                    dataIndex: 'userId',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '对应的用户信息',
                    dataIndex: 'nickName',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '支付订单号',
                    dataIndex: 'orderNo',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '错误信息',
                    dataIndex: 'exceptionRemark',
                    ellipsis: true,
                    align: 'center'
                },
            ]
        }
    },
    filters: {
    },
    created() {
        this.getList()
    },
    computed: {
    },
    watch: {
        activeKey(val, newval) {
           this.getList()
        }
    },
    methods: {
        /** 查询分销配置列表 */
        getList() {
            if (this.activeKey == 1) {
                this.loading = true
                pageOrder(this.queryParam).then(response => {
                    this.list = response.data.records
                    this.total = response.data.total
                    this.loading = false
                })
            } else {
                this.loading = true
                pageOrder2(this.queryParam).then(response => {
                    this.list = response.data.records
                    this.total = response.data.total
                    this.loading = false
                })
            }

        },

        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParam.pageNum = 1
            this.getList()
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParam = {
                type: undefined,
                title: undefined,
                num: undefined,
                pageNum: 1,
                pageSize: 10
            }
            this.handleQuery()
        },
        onShowSizeChange(current, pageSize) {
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        changeSize(current, pageSize) {
            this.queryParam.pageNum = current
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
            this.ids = this.selectedRows.map(item => item.id)
            this.single = selectedRowKeys.length !== 1
            this.multiple = !selectedRowKeys.length
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            var that = this
            const ids = row.id || this.ids
            if (row.id) {
                this.ids.push(row.id)
            }
            this.$confirm({
                title: '确认删除所选中数据?',
                content: '当前选中编号为' + ids + '的数据',
                onOk() {
                    const data = []
                    that.ids.map(id => data.push({ 'id': id }))
                    return delDistribution(data)
                        .then(() => {
                            that.onSelectChange([], [])
                            that.getList()
                            that.$message.success(
                                '删除成功',
                                3
                            )
                        })
                },
                onCancel() {
                    // 取消清空删除ids列表
                    that.ids = []
                }
            })
        },
        /** 导出按钮操作 */
        handleExport() {
            var that = this
            this.$confirm({
                title: '是否确认导出?',
                content: '此操作将导出当前条件下所有数据而非选中数据',
                onOk() {
                    that.download('user/distribution-config/export', {
                        ...that.queryParam
                    }, `分销配置_${new Date().getTime()}.xlsx`)
                },
                onCancel() { }
            })
        }
    }
}
</script>